import service from "../util/link"
import url from "../util/apiurl"


/**
 * 设备日志请求
 */
export function equipmentlog() {
    return new Promise((resolve, reject) => {
        service.request({
            url: url.equipmentlog,
            method: "get",

        }).then((ok) => {
            resolve(ok)
        }).catch((err) => {
            reject(err)
        })
    })
}
export function logpages(obj) {
    return new Promise((resolve, reject) => {
        service.request({
            url: url.equipmentlog,
            method: "get",
            params: {
                page: obj
            }
        }).then((ok) => {
            resolve(ok)
        }).catch((err) => {
            reject(err)
        })
    })
}
export function logInfo(codeid, startTime, endTime,page) {
    return new Promise((resolve, reject) => {
        service.request({
            url: url.equipmentlog,
            method: "get",
            params: {
                 codeid: (typeof (codeid) == 'number') || (typeof (codeid) == 'string') ? codeid : "",
                     startTime: (typeof (startTime) == 'number') || (typeof (startTime) == 'string') ? startTime : "",
                endTime: (typeof (endTime) == 'number') || (typeof (endTime) == 'string') ? endTime : "",
                      page: (typeof (page) == 'number') || (typeof (page) == 'string') ? page : ""
            }
        }).then((ok) => {
            resolve(ok)
        }).catch((err) => {
            reject(err)
        })
    })
}